import React, { ReactElement, useState } from 'react';
import { NavLink, useLocation, matchPath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthResources } from 'components';

// import useStyles from './useStyles';

const MenuBoxComp = (): ReactElement => {
  // const classes = useStyles();

  const { t } = useTranslation('leftMenu');

  function MenuPanel() {
    // const location = useLocation();
    if (matchPath(useLocation().pathname, { path: '/panel' })) {
      return (
        <>
          <NavLink to="/panel/tablica" className="linkItemMenu">
            <div className="accentBefore">
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                  fill="#fff"
                />
              </svg>
            </div>
            <div className="itemMenuBlock">
              <div className="accentActive" />
              <div className="iconItemMenu">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9.091 4.66666H5.69701C4.96267 4.66666 4.36366 5.26566 4.36366 6.00001V9.99999H6.06069V6.33331H9.091V4.66666ZM27.615 15.5383H25.918V19.205H22.8876V20.8717H26.2816C27.016 20.8717 27.615 20.2727 27.615 19.5383V15.5383ZM29.9697 23.3333H2.03033V2.00003H29.9697V23.3333ZM10.606 30.6666V31.3333C10.606 31.7006 10.9054 32 11.2727 32H20.7273C21.0946 32 21.394 31.7006 21.394 31.3333V30.6666C21.394 30.2993 21.0946 30 20.7273 30H19.0303C18.663 30 18.3636 29.7007 18.3636 29.3333V25.3333H29.6363C30.2733 25.3333 30.86 25.0443 31.2859 24.5757C31.7567 24.058 32 23.3627 32 22.6667V2.66663C32 1.971 31.7563 1.27569 31.2859 0.758334C30.86 0.289692 30.2737 0 29.6363 0H2.36364C0.939635 0 0 1.32065 0 2.66663V22.6667C0 23.3627 0.243325 24.058 0.713983 24.5753C1.14002 25.0443 1.72633 25.3333 2.36364 25.3333H13.6363V29.3333C13.6363 29.7007 13.337 30 12.9697 30H11.2727C10.9054 30 10.606 30.2993 10.606 30.6666Z" />
                </svg>
              </div>
              <div className="itemMenu">{t('menu.desktopUser')}</div>
            </div>
            <div className="accentAfter">
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                  fill="#fff"
                />
              </svg>
            </div>
          </NavLink>

          <>
            <NavLink to="/panel/teczka-pracownika/" className="linkItemMenu">
              <div className="accentBefore">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div className="itemMenuBlock">
                <div className="accentActive" />
                <div className="iconItemMenu">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.1131 14.3269L28.1675 11.3498C28.4443 11.0799 28.5441 10.6756 28.4246 10.3079C28.3051 9.93997 27.9871 9.67185 27.6044 9.6162L18.9976 8.36535L15.1486 0.566523C14.9773 0.219414 14.624 0 14.237 0C13.8502 0 13.4969 0.219619 13.3256 0.566523L9.47675 8.36535L0.86992 9.6162C0.487139 9.67185 0.169175 9.93987 0.049633 10.3079C-0.0697046 10.6756 0.0300674 11.0799 0.306858 11.3498L6.53467 17.4203L5.06439 25.9919C4.99927 26.3717 5.15723 26.7596 5.46878 26.9861C5.64264 27.1126 5.85145 27.1802 6.06628 27.1802C6.23118 27.1802 6.39322 27.1402 6.53915 27.0635L14.0904 23.0936L14.1175 23.5678C14.3876 28.2907 18.3187 32 23.0511 32C27.9854 32 32 27.9854 32 23.0511C32 19.0977 29.3892 15.6059 25.6112 14.4759L25.1131 14.3269ZM14.162 20.8569C14.023 20.8671 13.8876 20.9035 13.7641 20.9685L7.4161 24.306L8.62834 17.2374C8.6848 16.9083 8.57514 16.5708 8.33606 16.3377L3.20023 11.3317L10.2978 10.3002C10.6288 10.2521 10.915 10.0443 11.0631 9.7443L14.237 3.31282L17.4112 9.7442C17.5592 10.0441 17.8454 10.252 18.1763 10.3001L25.2738 11.3316L22.4081 14.125L22.2987 14.1342C18.5861 14.4445 15.4392 17.0541 14.4338 20.6346L14.3758 20.8411L14.162 20.8569ZM23.0511 29.9673C19.2373 29.9673 16.1349 26.8648 16.1349 23.0511C16.1349 19.2374 19.2373 16.135 23.0511 16.135C26.8648 16.135 29.9673 19.2374 29.9673 23.0511C29.9673 26.8649 26.8649 29.9673 23.0511 29.9673ZM25.1529 20.3934L21.9053 23.6409L20.8611 22.597C20.464 22.2 19.8208 22.2 19.4237 22.597C19.0267 22.9938 19.0268 23.6373 19.4237 24.0342L21.1865 25.7971C21.378 25.9885 21.6346 26.0947 21.9053 26.0947C22.1759 26.0947 22.4325 25.9884 22.6239 25.797L26.5902 21.8307C26.9872 21.4338 26.9872 20.7903 26.5902 20.3934C26.1933 19.9964 25.5498 19.9964 25.1529 20.3934Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="itemMenu">TECZKA PRACOWNIKA</div>
              </div>
              <div className="accentAfter">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
            <div className="subMenu">
              <div className="fill" />
              <div className="subMenuItemBox">
                <NavLink
                  to="/panel/teczka-pracownika/badania"
                  className="linkItemSubMenu"
                >
                  BADANIA
                </NavLink>
                <NavLink
                  to="/panel/teczka-pracownika/szkolenia"
                  className="linkItemSubMenu"
                >
                  SZKOLENIA
                </NavLink>
                <NavLink
                  to="/panel/teczka-pracownika/uprawnienia"
                  className="linkItemSubMenu"
                >
                  UPRAWNIENIA
                </NavLink>
              </div>
            </div>
          </>
        </>
      );
    }
  }

  return (
    <div className="menu">
      {MenuPanel()}

      <div className="fill" />
    </div>
  );
};

export default MenuBoxComp;
